/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon64Regular = forwardRef('UiFrameSizeMinIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M40.5 7A1.5 1.5 0 0 1 42 8.5v10a3.5 3.5 0 0 0 3.5 3.5h10a1.5 1.5 0 0 1 0 3h-10a6.5 6.5 0 0 1-6.5-6.5v-10A1.5 1.5 0 0 1 40.5 7Z" }),
        React.createElement("path", { d: "M8.5 39a1.5 1.5 0 0 0 0 3h10a3.5 3.5 0 0 1 3.5 3.5v10a1.5 1.5 0 0 0 3 0v-10a6.5 6.5 0 0 0-6.5-6.5h-10Z" }),
        React.createElement("path", { d: "M45.5 39a6.5 6.5 0 0 0-6.5 6.5v10a1.5 1.5 0 0 0 3 0v-10a3.5 3.5 0 0 1 3.5-3.5h10a1.5 1.5 0 0 0 0-3h-10Z" }),
        React.createElement("path", { d: "M25 8.5a1.5 1.5 0 0 0-3 0v10a3.5 3.5 0 0 1-3.5 3.5h-10a1.5 1.5 0 0 0 0 3h10a6.5 6.5 0 0 0 6.5-6.5v-10Z" })));
});
